<template>
    <div>
        <b-sidebar id="sidebar-1" title="Jelmagyarázat" right shadow class="elegant-sidebar">
        <div class="px-3 py-2" role="tablist">
          <!--<div>Checked names: {{ value }}</div>-->
          
          <!-- Select All / Select None Controls -->
          <div class="mb-3 d-flex">
            <b-button 
              @click="handleSelectAll"
              variant="outline-primary"
              size="sm"
              class="button-spacing"
            >
              Mindegyik
            </b-button>
            <b-button 
              @click="handleSelectNone"
              variant="outline-secondary"
              size="sm"
            >
              Egyik sem
            </b-button>
          </div>
          
          <b-form-checkbox-group
              id="selectedFeatures"
              v-model="value"
              name="selected-features"
              @input="$emit('input', $event)"
          >
            <b-card no-body class="mb-2 legend-card" v-for="attributeValue in attributeValues" :key="attributeValue.mnaId">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <table>
                        <tr>
                          <td>
                            <b-form-checkbox :value="attributeValue.mnaId" :id="attributeValue.mnaId"></b-form-checkbox>
                          </td>
                            <td>
                                <img :src="attributeValue.mapIconUrl" width="16" height="16"/>
                            </td>
                            <td>
                                {{attributeValue.name}}
                            </td>
                            <td>
                                <b-button v-if="attributeValue.attribImageUrl" block v-b-toggle="'accordion-'+attributeValue.mnaId" variant="info">+</b-button>
                            </td>
                        </tr>
                    </table>
                </b-card-header>
                <b-collapse v-bind:id="'accordion-' + attributeValue.mnaId" role="tabpanel" v-if="attributeValue.attribImageUrl">
                    <b-card-body>
                        <img :src="attributeValue.attribImageUrl" style="width: 100%" />
                    </b-card-body>
                </b-collapse>
            </b-card>
          </b-form-checkbox-group>
        </div>
        </b-sidebar>
    </div>
</template>

<script>
export default {
  props: {
    attributeValues: {},
    value: [],
    //selectedFeatures: []
  },
  methods: {
    handleSelectAll() {
      // Select all attribute values
      const allIds = this.attributeValues.map(item => item.mnaId);
      this.$emit('input', allIds);
    },
    handleSelectNone() {
      // Clear all selections
      this.$emit('input', []);
    }
  }
}
</script>

<style>
/* Elegant Sidebar - Museum Aesthetic */
.elegant-sidebar .b-sidebar-header {
    background: #faf9f7;
    color: #0f766e;
    padding: 1.25rem 1.5rem;
    font-weight: 600;
    font-size: 1.0625rem;
    letter-spacing: -0.01em;
    border-bottom: 1px solid #e2e8f0;
}

.elegant-sidebar .b-sidebar-body {
    background: white;
}

.legend-card {
    border: 1px solid #e2e8f0;
    border-radius: 0.375rem;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
    transition: all 0.25s ease;
    overflow: hidden;
    background: white;
}

.legend-card:hover {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
    border-color: #cbd5e1;
}

.legend-card .card-header {
    background: white;
    border-bottom: 1px solid #f1f5f9;
    padding: 0.625rem 0.875rem;
    transition: background-color 0.25s ease;
}

.legend-card:hover .card-header {
    background: #faf9f7;
}

.legend-card .card-body {
    padding: 0.875rem;
    background: #fefdfb;
}

td {
    padding: 6px 10px;
    vertical-align: middle;
}

.button-spacing {
    margin-right: 10px;
}

.btn-outline-primary {
    border: 1.5px solid #0f766e;
    color: #0f766e;
    font-weight: 500;
    border-radius: 0.375rem;
    transition: all 0.25s ease;
    background: white;
}

.btn-outline-primary:hover {
    background: #0f766e;
    color: white;
    border-color: #0f766e;
}

.btn-outline-secondary {
    border: 1.5px solid #64748b;
    color: #64748b;
    font-weight: 500;
    border-radius: 0.375rem;
    transition: all 0.25s ease;
    background: white;
}

.btn-outline-secondary:hover {
    background: #64748b;
    color: white;
    border-color: #64748b;
}

.btn-info {
    background-color: #0f766e;
    border: none;
    border-radius: 0.25rem;
    font-weight: 500;
    padding: 0.25rem 0.625rem;
    transition: all 0.25s ease;
    color: white;
}

.btn-info:hover {
    background-color: #115e59;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
}

/* Refined Checkbox Styling */
.custom-control-input:checked ~ .custom-control-label::before {
    background-color: #0f766e;
    border-color: #0f766e;
}

.custom-control-input:focus ~ .custom-control-label::before {
    box-shadow: 0 0 0 3px rgba(15, 118, 110, 0.08);
}

/* Smooth Collapse Animation */
.collapse {
    transition: height 0.3s ease;
}

/* Icon Styling */
img[width="16"] {
    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.08));
}
</style>